<template>
    <li>
      <div
        :id="'organization'+organization.organizationId"
        @click.prevent="selectOrganization(organization.organizationId)">&nbsp;
        <span v-if="hasChild" @click.prevent="toggle">
          <v-icon class="body-2 grey--text" v-if="open">indeterminate_check_box</v-icon>
          <v-icon class="body-2 grey--text" v-else>add_box</v-icon>
        </span>
        <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <v-icon class="body-2 blue-grey--text text--lighten-2">folder</v-icon>
          <span>
          {{ organization.name }}
          </span>
      </div>
      <ul v-show="open" v-if="hasChild">
        <tree-view
          v-for="(organization, index) in organization.children"
          :key="index"
          :organization="organization"
          @child-action="selectOrganization"
          >
        </tree-view>
      </ul>
    </li>
</template>

<script>

export default {
  // 再帰的に組織の階層を表示するコンポーネント
  props: {
    organization: Object
  },
  data () {
    return {
      open: true,
      selectedOrganizationId: null
    }
  },
  computed: {
    hasChild () {
      return this.organization.children &&
        this.organization.children.length
    },
    selectedOrganizationIdForTree () {
      return this.selectedOrganizationId
    }
  },
  methods: {
    toggle () {
      if (this.hasChild) {
        this.open = !this.open
      }
    },
    selectOrganization (organizationId) {
      this.selectedOrganizationId = organizationId
      this.$emit('child-action', organizationId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// TreeView.vue?621ece03